/**
 * Flickity Slider With Side Navigation.
 **/
export default function sideThumbsNavigation() {
  const sliderSections = document.querySelectorAll( '[data-type="molecule/sliders/side-thumbs-navigation"]' )

  if ( !sliderSections.length ) {
    return
  }

  sliderSections.forEach( sliderSection => sliderSideThumbsNavigation( sliderSection ) )

  /**
   * Slider side thumbs navigation callback.
   *
   * @param {object} sliderSection - The slider to add the Flickity functionality.
   **/
  function sliderSideThumbsNavigation( sliderSection ) {
    const carouselSelector = sliderSection.querySelector( '.carousel' )
    // eslint-disable-next-line no-undef
    const carousel = new Flickity( carouselSelector, {
      pageDots: false,
      contain: true
    })

    const carouselNav = sliderSection.querySelector( '.carousel-nav' )
    const carouselNavCells = carouselNav.querySelectorAll( '.carousel-cell' )

    const carouselNavMobile = sliderSection.querySelector( '.carousel-nav-mobile' )
    // eslint-disable-next-line no-undef
    new Flickity( carouselNavMobile, {
      pageDots: false,
      contain: true,
      asNavFor: carouselSelector
    })
    const carouselNavMobileCells = carouselNavMobile.querySelectorAll( '.carousel-cell' )

    /**
     * Set the navigation section same height as the slider main section.
     *
     * @param {object} carousel - The slider carousel.
     * @param {object} carouselNav - The slider carousel navigation.
     */
    const setCarouselNavHeight = ( carousel, carouselNav ) => {
      carouselNav.style.height = `${carousel.element.offsetHeight}px`
      carouselNav.style.maxHeight = `${carousel.element.offsetHeight}px`
    }

    setCarouselNavHeight( carousel, carouselNav )

    window.addEventListener( 'resize', () => {
      setCarouselNavHeight( carousel, carouselNav )
    })

    const placePlayButton = carouselNavCell => {
      const playButton = carouselNavCell.querySelector( '.video-play-icon' )

      if ( !playButton ) {
        return
      }

      // Get the image thumbnail height.
      const thumbnailImage = carouselNavCell.querySelector( 'img' )

      playButton.style.top = `-${( thumbnailImage.offsetHeight / 2 ) + ( playButton.offsetHeight / 2 )}px`
    }

    /**
     * Update selected slide.
     */
    for ( const [i, carouselNavCell] of carouselNavCells.entries() ) {
      carouselNavCell.addEventListener( 'click', () => {
        carousel.select( i )
      })

      placePlayButton( carouselNavCell )
    }

    /**
     * Update selected slide.
     */
    carouselNavMobileCells.forEach( carouselNavMobileCell => placePlayButton( carouselNavMobileCell ) )

    // eslint-disable-next-line no-undef
    const flkty = Flickity.data( carouselSelector )

    carousel.on( 'select', () => {
      carouselNav.querySelector( '.is-nav-selected' ).classList.remove( 'is-nav-selected' )

      /**
       * Change .entries or use IE polyfill.
       */
      for ( const [i, carouselNavCell] of carouselNavCells.entries() ) {
        if ( i === flkty.selectedIndex ) {
          carouselNavCell.classList.add( 'is-nav-selected' )
        }
      }

      const selected = carouselNav.querySelector( '.is-nav-selected' )
      scrollToElement( carouselNav, selected , 0.5 )
    })

    /**
     * Scroll to animation.
     *
     * @param {object} container - The slider container.
     * @param {object } element - Slider element.
     * @param {number} duration - Scroll duration.
     */
    const scrollToElement = ( container, element, duration ) => {
      const pos = getRelativePos( element )

      scrollTo( container, pos.top , duration ) // duration in seconds
    }

    const getRelativePos = element => {
      const pPos = element.parentNode.getBoundingClientRect() // parent pos
      const cPos = element.getBoundingClientRect() // target pos
      const pos = {}

      pos.top = cPos.top - pPos.top + element.parentNode.scrollTop
      pos.right = cPos.right - pPos.right
      pos.bottom = cPos.bottom - pPos.bottom
      pos.left = cPos.left - pPos.left

      return pos
    }

    const scrollTo = ( element, to, duration, onDone ) => {
      const start = element.scrollTop
      const change = to - start
      const startTime = performance.now()
      let now
      let elapsed
      let t

      const animateScroll = () => {
        now = performance.now()
        elapsed = ( now - startTime ) / 1000
        t = ( elapsed / duration )

        element.scrollTop = start + change * easeInOutQuad( t )

        if ( t < 1 ) {
          window.requestAnimationFrame( animateScroll )
        } else {
          onDone && onDone()
        }
      }

      animateScroll()
    }

    const easeInOutQuad = t => {
      return t < .5 ? 2 * t * t : -1 + ( 4 - 2 * t ) * t
    }
  }
}
